

export default function maxValue(data: number[]) {
    return data.reduce((a, b) =>  Math.max(a, b), 0)
}